import { Box, ThemeUIStyleObject } from 'theme-ui';
import React from 'react';

export interface RadioProps extends React.ComponentPropsWithRef<'input'> {
  large?: boolean;
  variant?: string;
  sx?: ThemeUIStyleObject;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(({ large, sx, variant, ...props }, ref) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative'
    }}
  >
    <input
      {...props}
      ref={ref}
      type="radio"
      sx={{
        // Make sure the checkbox is invisible but still rendered, so it can be focused
        position: 'absolute',
        zIndex: -1,
        overflow: 'hidden',
        width: 1,
        height: 1,
        opacity: 0
      }}
    />
    <Box
      aria-hidden="true"
      variant={variant?.includes('.') ? variant : `forms.${variant}`}
      sx={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: large ? 24 : 16,
        height: large ? 24 : 16,
        ...sx
      }}
    >
      <svg
        width={large ? 12 : 8}
        height={large ? 12 : 8}
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  </Box>
));

Radio.displayName = 'Radio';

Radio.defaultProps = {
  large: false,
  variant: 'radio'
};

export default Radio;
